import React, { useState } from 'react';
import Header from '../../mainpagecomponents/Header';
import { Box, Button, Container, Typography, Divider, Paper } from '@mui/material';
import BlogAccessCheckModal from './BlogAccessCheckModal';
import CurrentBlogs from './CurrentBlogs';
import FeaturedBlogs from './FeaturedBlogs';



const BlogHome = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Header />
            <Box sx={{ backgroundColor: '#FDFCF7', minHeight: '100vh', pt: 16, pb: 10 }}>
                <Container maxWidth="md">
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: 700, color: '#3F3F3F', mb: 2 }}
                    >
                        Welcome to the Gradely Blog
                    </Typography>

                    <Box textAlign="center" sx={{ mb: 6 }}>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#56643F',
                                color: 'white',
                                px: 4,
                                py: 1.5,
                                fontSize: '1rem',
                                fontWeight: 600,
                                '&:hover': {
                                    backgroundColor: '#404E2E',
                                },
                            }}
                            onClick={() => setShowModal(true)}
                        >
                            ✍️ Submit a Blog Post
                        </Button>
                    </Box>

                    <FeaturedBlogs />
                    <CurrentBlogs />
                </Container>
            </Box>

            {showModal && (
                <BlogAccessCheckModal onClose={() => setShowModal(false)} />
            )}
        </>

    );
};

export default BlogHome;